import {anythingDifferent, arrayDifferent, arrayReferenceDifferent, isSimpleObject, referenceDifferent, simpleObjectDifferent, simpleObjectValuesDifferent} from "./diff-utils.js"
import Shape from "./shape.js"
import {ShapeHook, useShapeHook} from "./shape-hook.js"
import shouldComponentUpdate from "./should-component-update.js"
import setState from "./set-state.js"
import useNow from "./use-now.js"
import useState from "./use-state.js"

export {
  anythingDifferent,
  arrayDifferent,
  arrayReferenceDifferent,
  isSimpleObject,
  referenceDifferent,
  shouldComponentUpdate,
  simpleObjectDifferent,
  simpleObjectValuesDifferent,
  Shape,
  ShapeHook,
  setState,
  useNow,
  useShapeHook,
  useState
}
